<template>
  <div
    class="mb-5 font-roboto relative z-[2] border-1 rounded-[20px] min-w-full p-[5px] tablet:p-[20px] bg-opacity-50 bg-[#fff] border-gray-300">
    <div
      class="border-0 w-full my-[0px] tablet:my-[5px] p-[20px] shadow-[0px_0px_10px_0px_#0000001A] rounded-[20px] bg-[#fff]">
      <div class="items-center gap-[12px] w-full pb-[10px] flex">
        <div class="flex items-center gap-[5px]">
          <span class="block w-[8px] h-[8px] rounded-full bg-[#F5B134]"></span>
          <span class="block w-[35px] h-[8px] rounded-full bg-[#F5B134]"></span>
        </div>
        <h1 class="m-0 text-[20px] font-roboto font-bold text-customBlue-100">Contact Us! We'll get in touch </h1>
      </div>
      <p class="text-sm font-normal">Have a question? Send us a message or reach our support team at <a
          href="tel:+18557976944" class="font-semibold underline text-base tablet:text-sm text-customBlue-100">(855) 797-6944</a></p>
      <div class="mt-[15px] pt-[15px] border-t border-[#EFEFEF]">
        <div class="grid grid-cols-2 gap-[15px] laptop:gap-x-[30px] pb-[20px]">
          <div class="flex flex-col gap-[3px] col-span-2 laptop:col-span-1">
            <label class="text-sm tablet:text-[16px] font-normal font-poppins text-[#666666] w-full"
              for="customFullName">First Name<span class="ml-1 text-red-500">*</span></label>
            <inputComponent ref="firstNameRef" v-model="first_name" name="firstName" required
              placeholder="Enter First Name" length="120"
              customClass="!text-[16px] font-poppins font-regular outline-none py-2 px-3 w-full rounded-[10px] border border-[#cccccc] placeholder:text-[#CCCCCC] text-[#333]" />
          </div>
          <div class="flex flex-col gap-[3px] col-span-2 laptop:col-span-1">
            <label class="text-sm tablet:text-[16px] font-normal font-poppins text-[#666666] w-full"
              for="customFullName">Last
              Name<span class="ml-1 text-red-500">*</span></label>
            <inputComponent ref="lastNameRef" v-model="last_name" name="lastName" required placeholder="Enter Last Name"
              length="120"
              customClass="!text-[16px] font-poppins font-regular outline-none py-2 px-3 w-full rounded-[10px] border border-[#cccccc] placeholder:text-[#CCCCCC] text-[#333]" />
          </div>
          <div class="flex flex-col gap-[3px] col-span-2">
            <label class="text-sm tablet:text-[16px] font-normal font-roboto text-[#666666] w-full"
              for="address">Service Address<span class="ml-1 text-red-500">*</span></label>
            <GoogleAutoComplete v-model="selectedServiceAddress.address" placeholder="Address"
              @place-selected="handlePlace" @address-reset="resetSelectedAddress"
              :input-class="'w-full px-3 py-[6px] !rounded-[10px] outline-none font-roboto text-[16px] placeholder:text-[#CCCCCC] text-[#333]'" />
            <p v-if="!selectedServiceAddress?.lat && isValidate" class="text-red-500 text-xs mb-0">This field
              is required.</p>
          </div>
          <div class="flex flex-col gap-[3px] col-span-2 laptop:col-span-1">
            <label class="text-sm tablet:text-[16px] font-normal font-poppins text-[#666666] w-full" for="Phone">Phone
              Number<span class="ml-1 text-red-500">*</span></label>
            <inputComponent ref="phoneRef" name="Phone" v-model="phone" mask="(###) ###-####" required
              placeholder="Enter Phone" length="120" error-message="Invalid Phone Number" type="tel"
              customClass="!text-[16px] font-poppins font-regular outline-none py-2 px-3 w-full rounded-[10px] border border-[#cccccc] placeholder:text-[#CCCCCC] text-[#333]" />
          </div>
          <div class="flex flex-col gap-[3px] col-span-2 laptop:col-span-1">
            <label class="text-sm tablet:text-[16px] font-normal font-poppins text-[#666666] w-full"
              for="Email">Email<span class="ml-1 text-red-500">*</span></label>
            <inputComponent ref="emailRef" name="Email" v-model="email" required placeholder="Enter Email" length="120"
              :regex="$constants.EMAIL_REGEX" error-message="Invalid Email"
              customClass="!text-[16px] font-poppins font-regular outline-none py-2 px-3 w-full rounded-[10px] border border-[#cccccc] placeholder:text-[#CCCCCC] text-[#333]" />
          </div>
          <div class="flex flex-col gap-[3px] col-span-2">
            <label class="text-sm tablet:text-[16px] font-normal font-poppins text-[#666666] w-full"
              for="message">Message<span class="ml-1 text-red-500">*</span></label>
            <textAreaComponent ref="messageRef" name="message" v-model="message" required placeholder="Message"
              length="500"
              customClass="!text-[16px] resize-none font-poppins font-regular outline-none py-2 px-3 w-full rounded-[10px] border border-[#cccccc] placeholder:text-[#CCCCCC] text-[#333]" />
          </div>
          <div class="col-span-2">
            <RecaptchaBox @verified="recaptchaVerified" ref="recaptchaRef" captchaWrapperClass="justify-start" />
          </div>
        </div>
        <div class="flex justify-center items-center">
          <button type="button" @click="submitClicked"
            class="w-[150px] h-[44px] cursor-pointer flex justify-center items-center mx-auto rounded-full text-base CustomBlueBtn">Submit</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import textAreaComponent from '../components/partialComponent/textAreaComponent.vue';
import inputComponent from '../components/partialComponent/inputComponent.vue';
import GoogleAutoComplete from '../components/partialComponent/GoogleAutoComplete.vue';
import RecaptchaBox from '../components/partialComponent/recaptchaBox.vue'
import { useToast } from "vue-toastification";
const toast = useToast();

export default {
  components: {
    inputComponent,
    textAreaComponent,
    GoogleAutoComplete,
    RecaptchaBox
  },
  emits: ["submitDetail"],
  data() {
    return {
      first_name: '',
      last_name: '',
      phone: '',
      email: '',
      message: '',
      isValidate: false,
      selectedServiceAddress: {
        "address": null,
        "lat": null,
        "lng": null
      },
      recaptchaToken: null,
    };
  },
  computed: {
    ...mapGetters([
      "contactUsResponse",
    ]),
  },

  watch: {
    contactUsResponse: function (data) {
      toast.success(this.contactUsResponse.message);
      this.reset()
    }
  },

  methods: {
    ...mapActions([
      "postContactUsForm",
    ]),

    reset() {
      this.first_name = '',
        this.last_name = '',
        this.phone = '',
        this.email = '',
        this.message = '',
        this.isValidate = false,
        this.selectedServiceAddress = {
          "address": null,
          "lat": null,
          "lng": null
        }
      this.recaptchaToken = null

      setTimeout(() => {
        let inputRefer = ["firstNameRef", "lastNameRef", "phoneRef", "emailRef", "messageRef"]
        inputRefer.forEach(ref => {
          const component = this.$refs[ref];
          const inputComponent = Array.isArray(component) ? component[0] : component;
          if (inputComponent && typeof inputComponent.resetField === "function") {
            inputComponent.resetField();
          }
        });
      }, 100);

    },

    isInValid() {
      this.isValidate = true
      let inputRefer = ["firstNameRef", "lastNameRef", "phoneRef", "emailRef", "messageRef"]
      let hasError = false;
      let firstInvalidField = null;
      inputRefer.forEach(ref => {
        const component = this.$refs[ref];
        const inputComponent = Array.isArray(component) ? component[0] : component;
        if (inputComponent && typeof inputComponent.validate === "function") {
          inputComponent.validate();
          if (inputComponent.hasError && !firstInvalidField) {
            firstInvalidField = inputComponent; // Store first invalid field
          }
          if (inputComponent.hasError()) {
            hasError = true;
          }
        }
      });

      if (firstInvalidField) {
        this.$nextTick(() => {
          firstInvalidField.$el.scrollIntoView({ behavior: "smooth", block: "center" });
        });
      }

      if ((this.selectedServiceAddress?.lat ?? 0) == 0) {
        hasError = true;
      } 

      if (!this.recaptchaToken) {
        toast.error("You must verify the reCAPTCHA before continuing.")
        hasError = true
      }

      return hasError;
    },

    handlePlace(place) {
      this.selectedServiceAddress = {
        address: place.formatted_address,
        lat: place.geometry?.location?.lat(),
        lng: place.geometry?.location?.lng(),
      }
      if ((this.selectedServiceAddress?.lat ?? 0) == 0) {
        this.isValidate = true
      } else {
        this.isValidate = false
      }
    },

    submitClicked() {
      if (!this.isInValid()) {
        this.$refs.recaptchaRef.resetCall()
        this.postContactUsForm({
          "first_name": this.first_name,
          "last_name": this.last_name,
          "email": this.email,
          "phone": this.phone,
          "message": this.message ?? "",
          "address": this.selectedServiceAddress.address,
          "lat": this.selectedServiceAddress.lat,
          "lng": this.selectedServiceAddress.lng,
          "recaptcha_token": this.recaptchaToken
        })
      }
    },

    recaptchaVerified(token) {
      this.recaptchaToken = token;
    },

    resetSelectedAddress() {
      this.isValidate = true
      this.selectedServiceAddress = {
        "address": null,
        "lat": null,
        "lng": null
      }
    },
  }
}
</script>